import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import { previewData } from './previewData';

export const previewDataSlice = createSlice({
    name: 'previewData',
    initialState: {
        status: 'waiting',
        data:{}
    },
    reducers: {
        getAuth: (state) => {
            state.data = { status: 'idle', data: [] };
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(previewData.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(previewData.fulfilled, (state, action) => {
            state.status = 'idle';
            state.data = action.payload;
        })
        .addCase(previewData.rejected, (state, action) => {
            state.status = 'idle';
            state.data = {};
        });
    },
});

export const { getAuth } = previewDataSlice.actions;
export default previewDataSlice.reducer;